import { CMS_HUB_PROFESSIONAL, MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
export const PopularFeaturesMap = {
  [MARKETING_HUB_PROFESSIONAL]: {
    campaignManagement: ['campaignManagement'],
    socialMedia: ['socialMedia'],
    websiteTrafficAnalytics: ['websiteTrafficAnalytics'],
    seoAnalytics: ['seoAnalytics'],
    omniChannelMarketingAutomation: ['omniChannelMarketingAutomation']
  },
  [SALES_HUB_PROFESSIONAL]: {
    sequences: ['sequences'],
    forecasting: ['forecasting'],
    prospectingWorkspace: ['prospectingWorkspace'],
    salesAutomation: ['salesAutomation'],
    playbooks: ['playbooks']
  },
  [SERVICE_HUB_PROFESSIONAL]: {
    sequences: ['sequences'],
    whatsAppIntegration: ['whatsAppIntegration', 'WhatsApp'],
    playbooks: ['playbooks'],
    videoHostingManagement: ['videoHostingManagement'],
    knowledgeBase: ['knowledgeBase']
  },
  [CMS_HUB_PROFESSIONAL]: {
    websiteTrafficAnalytics: ['websiteTrafficAnalytics'],
    forms: ['forms'],
    landingPages: ['landingPages'],
    videoHostingManagement: ['videoHostingManagement'],
    customReports: ['customReports']
  },
  [OPERATIONS_HUB_PROFESSIONAL]: {
    dataQualityCommandCenter: ['dataQualityCommandCenter'],
    programmableAutomation: ['programmableAutomation'],
    bulkDuplicateManagement: ['bulkDuplicateManagement'],
    dataQualityAutomation: ['dataQualityAutomation'],
    customReports: ['customReports']
  }
};